import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/layout';
import { LinkTester } from '@/components/features/payment-link/link-signer';
import { FORMAT_C1 } from '@/components/features/payment-link/link-signer/format-c1';

/**
 * Payment-Link Link-Tester — v1-Mount (Spec 501 Phase 7; scharf: Spec 503 Phase 7).
 *
 * Duenne Seiten-Huelle: PageHeader + der einstiegs-agnostische `LinkTester` mit der
 * echten „c=1"-Format-Definition (`FORMAT_C1`) — der Teaser ist aufgehoben, alle
 * scharfen Affordanzen sind aktiv. Platform-only am Route-Gate (`PAYMENT_LINK_READ`),
 * erreichbar ueber den Link von `/payment-link`. (`PENDING_FORMAT` bleibt im Kern als
 * Typ/Fallback fuer kuenftige Mounts.)
 */
export function PaymentLinkTesterPage() {
  const { t } = useTranslation('payment-link');
  return (
    <div>
      <PageHeader title={t('tester.title')} description={t('tester.subtitle')} />
      <LinkTester format={FORMAT_C1} />
    </div>
  );
}
